import React from 'react';

import Facebook from '../MainHeader/Facebook';
import Youtube from '../MainHeader/Youtube';
import Instagram from '../MainHeader/Instagram';

import './modal.scss';

import kris from './kris.jpg';
import karol from './karol.jpg';
import noPhoto from '../../images/about-no-photo.png';

const people = [{
  name: 'Kris',
  avatar: kris,
  email: 'k.kubis@customart.pl',
  tel: '+48 660 717 053'
}, {
  name: 'Karol',
  avatar: karol,
  email: 'k.kepka@customart.pl',
  tel: '+48 724 306 101',
}]

const ContactPerson = (props) => {
  return(
    <article className="contact-person">
      <div className="contact-person__avatar">
        <img src={props.avatar} className="contact-person__image" alt={props.name}/>
      </div>
      <div className="contact-person__content">
        <h3 className="contact-person__title">{props.name}</h3>
        <p className="contact-person__text">
          <a href={`tel:${props.tel}`} className="contact-person__email">{props.tel}</a>
        </p>
        <p className="contact-person__text">
          <a href={`mailto:${props.email}`} className="contact-person__email">{props.email}</a>
        </p>
      </div>
    </article>
  )
}

const ContactModal = (props) => (
  <div className="contact-modal">
    <dic className="contact-modal__overlay" onClick={props.onClose}/>
    <div className="contact-modal__content">
      <h2 className="contact-modal__title">Kontakt</h2>
      <div className="contact-modal__people">
        <ul className="contact-modal__list">
          {people.map((person, index) => (
            <li className="contact-modal__element" key={index}>
              <ContactPerson {...person} />
            </li>
          ))}
        </ul>
      </div>
      <div className="contact-modal__socials">
        <a
          href="https://www.facebook.com/customartagencja/"
          rel="noopener"
          target="_blank"
        ><Facebook /></a>
        <a
          href="https://www.youtube.com/channel/UCetpXU-6AoO_WA1IL1A_6_Q"
          rel="noopener"
          target="_blank"
        ><Youtube /></a>
        <a
          href="https://www.instagram.com/customart_agencja/"
          rel="noopener"
          target="_blank"
        ><Instagram /></a>
      </div>
    </div>
  </div>
);

export default ContactModal;



// WEBPACK FOOTER //
// ./src/components/Contact/Modal.js